module.exports = __webpack_public_path__ + "static/media/icon-youtube.3b999690.svg";